import BaseApi from "./BaseApi";

export default class AgendamentoService {

    static post(command) {
        return BaseApi.post(`agendamento/v1`, command);
    }

    static put(command) {
        return BaseApi.put(`agendamento/v1`, command);
    }

    static getByEventoCadastroAndOpcao(cdEventoCadastro, nrOpcao) {
        return BaseApi.get(`agendamento/v1/${cdEventoCadastro}/${nrOpcao}`);
    }

    static getDataAgendamento(cdEventoCadastro, nrOpcao, cdLocal) {
        return BaseApi.get(`agendamento/v1/getDataAgendamento/${cdEventoCadastro}/${nrOpcao}/${cdLocal}`);
    }

    static getPaginado(pagina, tamanhoPagina) {
        return BaseApi.get(`agendamento/v1/getAgendamentos/${pagina}/${tamanhoPagina}`);
    }

    static getHoraAgendamento(cdEventoCadastro, cdLocal, dia, mes, ano) {
        return BaseApi.get(`agendamento/v1/getHoraAgendamento/${cdEventoCadastro}/${cdLocal}/${dia}/${mes}/${ano}`);
    }

}